import { RouterActionTypes } from "./router.action.types";
export var AddRouteConfiguration = function (configuration) { return ({
    type: RouterActionTypes.ADD_ROUTE_CONFIGURATION,
    payload: configuration
}); };
export var UpdateRouteConfiguration = function (configuration) { return ({
    type: RouterActionTypes.UPDATE_ROUTE_CONFIGURATION,
    payload: configuration
}); };
//# sourceMappingURL=addRouteConfiguration.action.js.map